export default "__VITE_ASSET__uPlzcw5y__"